import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerApplicationQueryKeys } from "./keys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { CreateUpdateCustomerApplicationFormFields } from "../../models/CustomerApplication/CreateUpdateCustomerApplication";

export default function useCustomerApplicationsMutations(customerId: string) {
  const queryClient = useQueryClient();
  const { saveHandlers } = useDefaultCRUDHandlers("Customer Application");
  const { put, post } = useApiHelper();

  const create = useMutation({
    mutationFn: (newApplication: CreateUpdateCustomerApplicationFormFields) =>
      post(`/customer/${customerId}/applications`, newApplication),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerApplicationQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const update = useMutation({
    mutationFn: (updatedApplication: CreateUpdateCustomerApplicationFormFields) =>
      put(
        `/customer/${customerId}/applications/${updatedApplication.id}`,
        updatedApplication
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerApplicationQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  return {
    create,
    update,
  };
}
